import { inject, onMounted } from "vue";

export default function (widget, itemref, formData) {
  const { getInstanceList } = inject("instance");

  const instanceList = getInstanceList();

  const handleOnClick = (event) => {
    if (!!widget.options.onClick) {
      let customFunc = new Function("event", widget.options.onClick);
      customFunc.call(itemref.value, event);
    }
  };

  const handleOnFocus = (event) => {
    if (!!widget.options.onFocus) {
      let customFunc = new Function("event", widget.options.onFocus);
      customFunc.call(itemref.value, event);
    }
  };

  const handleOnBlur = (event) => {
    if (!!widget.options.onChange) {
      let customFunc = new Function("event", widget.options.onChange);
      customFunc.call(itemref.value, event);
    }
  };

  const handleOnInput = (val) => {
    if (!!widget.options.onInput) {
      let customFunc = new Function("value", widget.options.onInput);
      customFunc.call(itemref.value, val);
    }
  };

  const handleOnChange = () => {
    if (!!widget.options.onChange) {
      let customFunc = new Function("value", widget.options.onChange);
      customFunc.call(itemref.value, formData[widget.name]);
    }
  };

  const handleOnPressEnter = () => {
    if (!!widget.options.onPressEnter) {
      let customFunc = new Function(widget.options.onPressEnter);
      customFunc.call(itemref.value);
    }
  };

  //Mounted
  const handleOnMounted = () => {
    if (!!widget.options.onMounted) {
      let customFunc = new Function(widget.options.onMounted);
      customFunc.call(itemref.value);
    }
  };

  onMounted(() => handleOnMounted());

  //Created
  const init = () => {
    //初始化
    if (!formData[widget.name]) {
      if (widget.type == "select") {
        formData[widget.name] = widget.options.mode == "comboboox" ? null : [];
      } else {
        formData[widget.name] = widget.options.defaultValue || null;
      }
    }

    instanceList[widget.name] = itemref;
  };
  init();

  return {
    handleOnClick,
    handleOnFocus,
    handleOnBlur,
    handleOnInput,
    handleOnChange,
    handleOnPressEnter,
  };
}
